import { ChangeEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { useFetch } from "../../../../hooks/useFetch";
import { Equipment } from "../../../../types/types";
import Spinner from "../../../../ui/Spinner/Spinner";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
import { t } from "i18next";
import { Input } from "../../../../ui/Input/Input";
import { useAppStore } from "../../../../stores/RootStore";
import { Button } from "../../../../ui/Button";

export const CalculationsTab = ({equipment, updateEquipment}:{equipment:Equipment, updateEquipment: Function}) => {
  const { equipments, setEquipments } = useAppStore();
  const [stopThreshold, setStopThreshhold] = useState(equipment.attributes.stop_threshold ? equipment.attributes.stop_threshold : 0)
  const [alpha, setAlpha] = useState<boolean>(equipment.attributes.algo_type === "alpha" ? true : false)
  const [correctMaintenanceLoad, setCorrectMaintenanceLoad] = useState<boolean>(equipment.attributes.correct_maintenance_load)
  const [isMain, setIsMain] = useState<boolean>(equipment.attributes.is_main)
  const [{ response: itemUpdateResponse, isLoading: itemUpdateIsLoading, error: itemUpdateError }, doFetchItemUpdate] = useFetch(`/directories/equipment_items/${equipment.id}`);

  function handleChangeStopThreshold(e: ChangeEvent<HTMLInputElement>) {
    setStopThreshhold(e.target.valueAsNumber)
    let data = {stop_threshold: e.target.valueAsNumber} 
    onUpdate(data)
  }

  function handleChangeAsyncAlgorithm(value: boolean) {
    setAlpha(value)
    let data
    if(value) {
      data = {algo_type: "alpha"} 
    } else {
      data = {algo_type: "no_algo"} 
    }
    onUpdate(data)
  }

  function handleChangeCorrectMaintenanceLoad(value: boolean) {
    setCorrectMaintenanceLoad(value)
    let data = {correct_maintenance_load: value} 
    onUpdate(data)
  }

  function handleChangeIsMain(value: boolean) {
    setIsMain(value)
    let data = {is_main: value} 
    onUpdate(data)
  }

  const onUpdate = (formData: any) => {
    doFetchItemUpdate({
      method: "PUT",
      data: {
        data: formData,
      },
    });
  };

  useEffect(() => {
    if (!itemUpdateResponse) return;
    const newEquipmentData = itemUpdateResponse.data as unknown as Equipment;
    updateEquipment(newEquipmentData)
    const withoutEquipment = equipments?.filter((equipment) => equipment.id != equipment.id)!;
    setEquipments([...withoutEquipment, newEquipmentData]);
  }, [itemUpdateResponse]);

  return (
    <div className="relative flex flex-col w-full h-full overflow-hidden bg-background max-w-[1008px]">
      <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
        <div className="flex flex-col space-y-1">
          <span className="text-2xl font-semibold">{t('equipment_calculations')}</span>
        </div>
      </div>
      <div className="relative flex pb-10 h-full w-full overflow-hidden">
        <ScrollArea className="w-full">
          <div className="px-6 flex flex-col gap-2">
            <div className="flex flex-row w-full p-4 border border-border text-sm rounded gap-4">
              <div className="w-full">
                <div className="font-medium text-base">{t("set_equipment_as_additional")}</div>
                <div>{t("set_equipment_as_additional_desc")}</div>
              </div>
              <div className="flex-none w-32 justify-between items-center">
                  <Button variant={"outline"} size={"datepicker"} className="w-full" onClick={() => handleChangeIsMain(!isMain)}>{isMain ? t('turned_off') : t('turned_on')}</Button>
              </div>
            </div>
            <div className="flex flex-row w-full p-4 border border-border text-sm rounded gap-4">
              <div className="w-full">
                <div className="font-medium text-base">{t("stop_threshold")}</div>
                <div>{t("stop_threshold_desc")}</div>
              </div>
              <div className="flex-none w-32  justify-between items-center">
                  <Input
                    type="number"
                    max={600}
                    className="h-8 w-32"
                    value={stopThreshold}
                    onChange={(e) => handleChangeStopThreshold(e)}
                  />
              </div>
            </div>
            <div className="flex flex-row w-full p-4 border border-border text-sm rounded gap-4">
              <div className="w-full">
                <div className="font-medium text-base">{t("async_algorithm")}</div>
                <div>{t("async_algorithm_desc")}</div>
              </div>
              <div className="flex-none w-32 justify-between items-center">
                  <Button variant={"outline"} size={"datepicker"} className="w-full" onClick={() => handleChangeAsyncAlgorithm(!alpha)}>{alpha ? t('turned_on') : t('turned_off')}</Button>
              </div>
            </div>
            <div className="flex flex-row w-full p-4 border border-border text-sm rounded gap-4">
              <div className="w-full">
                <div className="font-medium text-base">{t("correct_with_maintenance_load")}</div>
                <div>{t("correct_with_maintenance_load_desc")}</div>
              </div>
              <div className="flex-none w-32 justify-between items-center">
                  <Button variant={"outline"} size={"datepicker"} className="w-full" onClick={() => handleChangeCorrectMaintenanceLoad(!correctMaintenanceLoad)}>{correctMaintenanceLoad ? t('turned_on') : t('turned_off')}</Button>
              </div>
            </div>
          </div>
        </ScrollArea>
      </div>
    </div>
  )
};
